<template>
  <q-dialog persistent v-model="requestDeleteDialog" class="bg-red-6">
    <q-card style="width: 90vw">
      <q-bar class="bg-red text-white">
        <q-icon name="warning" size="sm" color="orange"></q-icon>
        <div class="text-h6">Request Delete</div>
        <q-space />
        <q-btn
          class="q-pl-xs q-ml-md"
          flat
          v-close-popup
          @click="showDialog = false"
          dense
          icon="close"
        />
      </q-bar>

      <DeleteMessageTitle
        :deleteTitle="deleteTitle"
        :deleteMessage="deleteMessage"
      />
      <div class="q-pa-sm">
        <div class="row justify-end">
          <q-btn
            class="q-pa-xs"
            dense
            color="red"
            no-caps
            label="Delete Account"
            icon-right="delete"
            style="min-width: 120px"
            @click="yesDelete()"
          >
          </q-btn>
          <q-list class="fit q-ma-sm">
            <q-input
              class="full-width"
              dense
              outlined
              v-model="requestToDelete.remarks"
              type="textarea"
              label="Remarks"
            >
            </q-input>
            <q-checkbox
              v-model="requestToDelete.force"
              color="blue-5"
              label="Force"
            >
              <q-tooltip class="bg-primary">Force request to Delete</q-tooltip>
              <span>
                <q-badge
                  :class="
                    hasPackage ? 'text-red bg-white' : 'bg-white text-grey'
                  "
                  >{{ hasPackage ? "*" : "(Optional)" }}</q-badge
                >
              </span>
            </q-checkbox>
          </q-list>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script setup>
import { ref } from "vue";
import DeleteMessageTitle from "src/components/settings/DeleteAccount/DeleteMessageTitle/DeleteMessageTitle.vue";
import { useQuasar } from "quasar";

const props = defineProps({
  deleteTitle: {
    type: String,
  },
  deleteMessage: {
    type: String,
  },
  hasPackage: {
    type: Boolean,
  },
});
const requestDeleteDialog = ref(false);
const requestToDelete = ref({ force: false });
const $q = useQuasar();
let resolvePromise;
const openDialog = () => {
  requestDeleteDialog.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
};

async function yesDelete() {
  if (!requestToDelete.value.force && props.hasPackage) {
    $q.notify({
      type: "warning",
      message: "You have/had subscription, you must force delete !",
    });
    return;
  }
  resolvePromise(requestToDelete.value);
  requestDeleteDialog.value = false;
}
defineExpose({ openDialog });
</script>
